import Service from "../../../api/api-service";
import { ApiUrl } from "../../../api/api-url";

const service = new Service();
export const UpdateGeogisColumnData = async (body) => {
  try {
    return await service
      .post(ApiUrl.UpdateGeogisColumnData, body)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  } catch (err) {
    throw err;
  }
};

export const AddGeogisColumn = async (tableName, column, type = 'text') => {
  const params = new URLSearchParams();
  params.append("tableName", tableName);
  params.append("column", column);
  params.append("type", type);

  return service
    .get(ApiUrl.AddGeogisColumn, params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

